import React from 'react'

import './Icon.scss'

export type ModalIconPosition = 'left' | 'center'
export interface ModalIconProps {
  children: React.ReactNode
  position?: ModalIconPosition
  'data-testid'?: string
}

const ModalIcon = React.memo(
  ({
    position = 'left',
    children,
    'data-testid': dataTestId = 'modal-icon',
  }: ModalIconProps) => {
    return (
      <div
        data-testid={dataTestId}
        className={['ModalIcon', `ModalIcon--${position}`].join(' ')}
      >
        {children}
      </div>
    )
  },
)

ModalIcon.displayName = 'Modal.Icon'

export default ModalIcon
